import { render } from "./Details.vue?vue&type=template&id=b3d4d738"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"
script.render = render

export default script